<form #contactForm="ngForm">
  <section class="form newsletter" [hidden]="isSended">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>Anmeldung zu video2manual-Aktualisierungen</h2>
      <p>
        Neuigkeiten rund um die Software-Lösung von isb: Bleiben Sie auf dem
        Laufenden.
      </p>
    </div>
    <div class="salutation">
      <select
        class="form-control"
        id="salutation"
        name="salutation"
        [(ngModel)]="salutation"
        [disabled]="isSending || isSended"
      >
        <option value="" disabled>Anrede</option>
        <option value="Frau">Frau</option>
        <option value="Herr">Herr</option>
      </select>
    </div>
    <div class="lastname">
      <input
        type="text"
        class="form-control"
        placeholder="Nachname"
        id="lastname"
        name="lastname"
        [(ngModel)]="lastname"
        [disabled]="isSending || isSended"
      />
    </div>
    <div class="firstname">
      <input
        type="text"
        class="form-control"
        placeholder="Vorname"
        id="firstname"
        name="firstname"
        [(ngModel)]="firstname"
        [disabled]="isSending || isSended"
      />
    </div>
    <div class="email">
      <input
        type="email"
        class="form-control"
        placeholder="E-Mail-Adresse"
        id="email"
        name="email"
        [(ngModel)]="email"
        [disabled]="isSending || isSended"
        required
      />
    </div>
    <div class="phone">
      <input
        type="text"
        class="form-control"
        placeholder="Telefonnummer"
        id="phone"
        name="phone"
        [(ngModel)]="phone"
        [disabled]="isSending || isSended"
      />
    </div>
    <div class="company">
      <input
        type="text"
        class="form-control"
        placeholder="Firma"
        id="company"
        name="company"
        [(ngModel)]="company"
        [disabled]="isSending || isSended"
      />
    </div>
    <div class="privacy">
      <input
        type="checkbox"
        id="privacy"
        name="privacy"
        [(ngModel)]="privacy"
        [disabled]="isSending || isSended"
        required
      />
      <label for="privacy"
        >Ich erkenne den
        <a [routerLink]="['/privacy']">Datenschutz</a> an.</label
      >
    </div>
    <div class="send">
      <button
        class="send"
        (click)="send()"
        [disabled]="!contactForm.form.valid || isSending || isSended"
      >
        Absenden
      </button>
    </div>
  </section>
  <section class="form newsletter" [hidden]="!isSended">
    <div class="picture">
      <img src="assets/v2m-logo.svg" />
    </div>
    <div class="text">
      <h2>Information über Neuigkeiten zu video2manual</h2>
      <p>Vielen Dank dass Sie sich für video2manual interessieren.</p>
      <p>
        Wir werden Sie ab sofort in unregelmäßigen Abständen über Neuerungen
        rund um video2manual informieren.
      </p>
    </div>
  </section>
  <section class="contact">
    <div class="contact-info">
      <div class="address">
        <h2>Haben Sie weitere Fragen zu unserem Produkt video2manual?</h2>
        <p>Dieses Gespräch wird sich lohnen!</p>
        <h2>0049 (0) 2955 / 747 22 - 0</h2>
        <a href="mailto:info@video2manual.de" class="call"
          >... oder schreiben Sie uns eine Mail!</a
        >
        <h2>info@video2manual.de</h2>
      </div>
      <div class="question">
        <img src="assets/information.png" />
      </div>
    </div>
  </section>
  <section class="map">
    <div class="address">
      <p>
        ISB Information und Kommunikation GmbH & Co. KG<br />
        Lindberghring 6a, 33142 Büren
      </p>
      <a
        href="https://www.google.de/maps/dir//ISB+Information+und+Kommunikation+GmbH+%26+Co.+KG,+Lindberghring+6,+33142+B%C3%BCren/@51.60732,8.6117813,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47bbb613074a4019:0x80528c7d09dbb1df!2m2!1d8.61397!2d51.60732"
        target="_blank"
        >zum Routenplaner</a
      >
    </div>
  </section>
</form>
